// 表示しているページだったらヘッダーに下線表示
const headerMenus = document.querySelectorAll(".header__main-menu-link");
for (let menu of headerMenus) {
  if (document.URL.match(menu.href)) {
    menu.childNodes[1].classList.add("header__active-menu-item");
  }
}

// クリックしたらopen-menuクラス付与
const addOpenClass = (menus) => {
  for (let menu of menus) {
    menu.addEventListener("click", () => {
      menu.classList.toggle("open-menu");
    });
  }
};

// ドロワーメニュー
const drawerParentMenus = document.querySelectorAll(
  ".menu-drawer__menu-parent"
);
addOpenClass(drawerParentMenus);

// 検索アイコン
if (window.matchMedia("(min-width: 990px)").matches) {
  const headerSearchBtn = document.getElementById("header__search");
  headerSearchBtn.addEventListener(
    "mouseover",
    () => {
      headerSearchBtn.open = true;
    },
    false
  );
  headerSearchBtn.addEventListener(
    "mouseout",
    () => {
      headerSearchBtn.open = false;
    },
    false
  );
  const SearchModal = document.querySelector(".search-modal");
  SearchModal.addEventListener(
    "mouseout",
    () => {
      headerSearchBtn.open = false;
    },
    false
  );
  SearchModal.addEventListener(
    "blur",
    () => {
      headerSearchBtn.open = false;
    },
    false
  );
}

// つみきやコンテンツiframeにwrapper追加
const tsumikiyaIframe = document.querySelectorAll(".tsumikiya_contents iframe");
tsumikiyaIframe.forEach((iframe) => {
  iframe.outerHTML =
    '<div class="iframe_wrapper">' + iframe.outerHTML + "</div>";
});

if (!location.pathname.match(/login/)) {
  $(function () {
    var headerHight = 80;
    $('a[href^="#"]').click(function () {
      var speed = 500;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? "html" : href);
      var position = target.offset().top - headerHight;
      $("html, body").animate({ scrollTop: position }, speed, "swing");
      return false;
    });
  });
}

// ドロワー以外をクリックで閉じる
document.addEventListener("click", (e) => {
  let drawer = document.querySelector(
    "#Details-menu-drawer-container.menu-opening"
  );
  if (drawer) {
    if (!e.target.closest("#menu-drawer")) {
      drawer.setAttribute("aria-expanded", "false");
      drawer.classList.remove("menu-opening");
      drawer.removeAttribute("open");
      document.body.classList.remove(`overflow-hidden-tablet`);
    }
  }
});

window.addEventListener("DOMContentLoaded", () => {
  // 表示しているページURL
  let pathname = location.pathname;
  // 来訪元ページ
  let referrer = document.referrer;

  // 閲覧開始ページを設定
  if (!sessionStorage.getItem("pathname")) {
    sessionStorage.setItem("pathname", pathname);
  }
  // 来訪元ページを設定
  if (!sessionStorage.getItem("referrer")) {
    sessionStorage.setItem("referrer", referrer);
  }

  // カートページでフォームにセットする
  if (location.pathname.match(/cart/)) {
    document.getElementById("startPathname").value =
      sessionStorage.getItem("pathname");

    document.getElementById("referrer").value =
      sessionStorage.getItem("referrer");
  }

  // 商品ページ以外を表示した時に
  if (location.pathname.match(/collections/)) {
    const collectionsProducts = document.getElementById("ProductGridContainer")
      .dataset.collection_products;
    sessionStorage.setItem("collectionsProducts", collectionsProducts);
  } else if (!location.pathname.match(/products/)) {
    sessionStorage.setItem("collectionsProducts", "");
  }
});
